(function () {

    // ReSharper disable once UseOfImplicitGlobalInFunctionScope
    angular
        .module('smartertoolsApp')
        .controller('authenticationModalsController', ['$scope', '$timeout', 'authenticationService', authenticationModalsController]);

    function authenticationModalsController($scope, $timeout, authenticationService) {
        const vm = this;
        vm.attemptedSubmit = false;
        vm.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        vm.login = { emailAddress: '', password: '', rememberMe: true };
        vm.user = {
            FirstName: '',
            LastName: '',
            Company: '',
            PhoneNumber: '',
            EmailAddress: '',
            Password: ''
        };
        vm.agreement = { subject: '', body: '', type: '', isAccepted: false };

        // Functions
        vm.cancelAndRedirect = cancelAndRedirect;
        vm.closeWindow = closeWindow;
        vm.createUser = createUser;
        vm.doAgreementAccepted = doAgreementAccepted;
        vm.doLogin = doLogin;
        vm.doLogout = doLogout;
        vm.forgotPasswordGoButtonClick = forgotPasswordGoButtonClick;
        vm.hideForgotPasswordAndShowLogin = hideForgotPasswordAndShowLogin;
        vm.modalResetErrors = modalResetErrors;
        vm.resetErrors = resetErrors;
        vm.showCreateAccountModal = showCreateAccountModal;
        vm.showForgotPasswordModal = showForgotPasswordModal;
        vm.showLoginOverlay = showLoginOverlay;
        vm.showTermsAgreementOverlay = showTermsAgreementOverlay;
        activate();

        // -----------------------------------------------

        function activate() {
            if (window.showAccountCreation) {
                $timeout(ShowCreateAccountModal, 250);
            }
        }

        function createUser() {
            if (vm.newUserForm.$invalid)
                return false;
            vm.status = 'submitting';

            // Validation for phone number will not pass for empty strings.  Must be null if not present
            vm.user.PhoneNumber = vm.user.PhoneNumber != '' ? vm.user.PhoneNumber : null;
            authenticationService.createAccount(vm.user,
                true,
                function (err) {
                    vm.status = 'done';
                    if (err) {
                        window.RenderErrors(err, '#create-account-modal', '#NewUser');
                        window.RefreshLoginTopArea();
                    } else {
                        window.RefreshLoginTopArea();
                        bootstrap.Modal.getOrCreateInstance(document.getElementById('create-account-modal')).hide();
                        //vm.modalPageCreateAccount = 'step2';
                    }
                    $scope.$applyAsync();
                });
            return false;
        }

        function closeWindow() {
            window.RefreshLoginTopArea();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('create-account-modal')).hide();
        }

        function doLogin() {
            if (vm.loginModalForm.$invalid)
                return;

            vm.resetErrors();
            vm.status = 'submitting';
            authenticationService.login(vm.login.emailAddress,
                vm.login.password,
                vm.login.rememberMe,
                function (err) {
                    vm.status = '';
                    if (err) {
                        window.RenderErrors(err, '#login-modal', '#Login');
                        if (!err.ModelState) {
                            vm.login.password = '';
                            $scope.$applyAsync();

                            const loginPassword = document.getElementById('LoginPassword');
                            loginPassword.focus();
                            loginPassword.select();
                        }
                    } else {
                        vm.login.emailAddress = '';
                        vm.login.password = '';
                        $scope.$applyAsync();
                        bootstrap.Modal.getOrCreateInstance(document.getElementById('login-modal')).hide();
                        if (window.loginOverlayCallback)
                            window.loginOverlayCallback();
                    }
                    window.RefreshLoginTopArea();
                });
        }

        function doAgreementAccepted() {
            authenticationService.sendAccepted((data) => {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('partner-agreement')).hide();
                if (window.loginOverlayCallback)
                    window.loginOverlayCallback();
                window.RefreshLoginTopArea();
            });
        }

        function cancelAndRedirect() {
            doLogout();
        }

        function doLogout() {
            document.querySelector('#LoginEmailAddress').value = '';
            document.querySelector('#LoginPassword').value = '';
            authenticationService.logout(() => { RefreshLoginTopArea(); });
        }

        function forgotPasswordGoButtonClick() {
            if (vm.forgotPasswordForm.$invalid)
                return;

            modalResetErrors();
            mySpinner.setElement('forgot-password-modal');
            authenticationService.resetPassword(vm.user.EmailAddress,
                function (err) {
                    if (err) {
                        document.querySelector('#forgot-password-modal .error-message').textContent = 'Please enter a valid email address';
                        const forgotPasswordEmail = document.querySelector('#ForgotPasswordEmailAddress');
                        forgotPasswordEmail.value = '';
                        forgotPasswordEmail.focus();
                        forgotPasswordEmail.select();
                    } else {
                        mySpinner.setElement();
                        vm.modalPageForgotPassword = 'step2';
                    }
                    $scope.$applyAsync();
                });
        };

        function hideForgotPasswordAndShowLogin() {
            bootstrap.Modal.getOrCreateInstance(document.getElementById('forgot-password-modal')).hide();
            showLoginOverlay();
        };

        function modalResetErrors() {
            vm.newUserForm.$setPristine();
            vm.newUserForm.$setUntouched();
            vm.forgotPasswordForm.$setPristine();
            vm.forgotPasswordForm.$setUntouched();
            vm.loginModalForm.$setPristine();
            vm.loginModalForm.$setUntouched();
            resetErrors();
        };

        function resetErrors() {
            document.querySelectorAll('.error-message').forEach(element => {
                element.textContent = '';
                element.style.display = 'none';
            });

            document.querySelectorAll('.server-side-error').forEach(element => {
                element.classList.remove('server-side-error');
            });
        }

        function showCreateAccountModal(overlayCallback) {
            if (authenticationService.isLoggedIn())
                return;

            modalResetErrors();
            loginOverlayCallback = overlayCallback;
            vm.modalPageCreateAccount = 'step1';
            bootstrap.Modal.getOrCreateInstance(document.getElementById('login-modal')).hide();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('create-account-modal')).show();
            $timeout(() => {
                var newUserFirstName = document.getElementById('NewUserFirstName');
                newUserFirstName.focus();
                newUserFirstName.select();
            }, 250);
        }

        function showForgotPasswordModal() {
            modalResetErrors();
            vm.user.EmailAddress = vm.login.emailAddress;
            vm.modalPageForgotPassword = 'step1';
            bootstrap.Modal.getOrCreateInstance(document.getElementById('login-modal')).hide();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('forgot-password-modal')).show();
            $timeout(() => {
                const defaultElement = document.getElementById('ForgotPasswordEmailAddress');
                defaultElement.focus();
                defaultElement.select();
            }, 250);
        }

        function showLoginOverlay(overlayCallback) {
            modalResetErrors();
            loginOverlayCallback = overlayCallback;

            document.getElementById('LoginEmailAddress').value = '';
            document.getElementById('LoginPassword').value = '';
            document.querySelectorAll('.error-message').forEach(x => x.innerHTML = '');

            bootstrap.Modal.getOrCreateInstance(document.getElementById('login-modal')).show();
            $timeout(() => {
                const defaultElement = document.getElementById('LoginEmailAddress');
                defaultElement.focus();
                defaultElement.select();
            }, 250);
        }

        function showTermsAgreementOverlay() {
            authenticationService.getAgreement(function (data) {
                vm.agreement.body = data.Body;
                vm.agreement.subject = data.Subject;
                vm.agreement.type = data.Type;
                bootstrap.Modal.getOrCreateInstance(document.getElementById('partner-agreement')).show();
            });
        }
    }

})();